<template>
  <div class="location-card">
    <b-card no-body border-variant="light" class="form-card bg-white">
      <b-container fluid>
        <b-row no-gutters id="contact-row" class="contact-row">
          <!-- Logo Column -->
          <b-col md="4" sm="6" xs="6" class="cityicon p-3">
            <img :src="require(`@/assets/${lenderImage}`)"  class="large-logo"/>
            <h6>{{ lenderName }}</h6>
          </b-col>

          <b-col md="8" sm="8" xs="8" class="p-3">
            <div class="address address-text mb-3">
              <h6>Grievance Redressal Officer:</h6>
            <h6><a v-if="lenderGrievanceRedressalOfficer" :href="lenderGrievanceRedressalOfficer" target="_blank"  rel="noopener noreferrer">{{ lenderGrievanceRedressalOfficer }}</a></h6>
            </div>
            <div class="mb-3">
              <h6>Privacy Policy</h6>
              <h6><a v-if="lenderPrivacyPolicy" :href="lenderPrivacyPolicy" target="_blank" rel="noopener noreferrer">{{ lenderPrivacyPolicy }}</a></h6>
            </div>
            <div class="mb-3">
              <h6>Product details</h6>
              <h6><a v-if="lenderProductDetails" :href="lenderProductDetails" target="_blank"      rel="noopener noreferrer">{{ lenderProductDetails }}</a></h6>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "lenderCard",
  props: [
    "lenderName",
    "lenderGrievanceRedressalOfficer",
    "lenderPrivacyPolicy",
    "lenderProductDetails",
    "lenderImage",
    "callIcon",
  ],
};
</script>

<style scoped>
/* ... existing styles ... */
.large-logo {
  width: 130px;  
  height: auto;
  margin-bottom: 1rem; /* space between logo and name */
}
.form-card {
  border-radius: 12px;
  width: 130%;
  padding: 1rem;
  border: 1px solid #d3d3d3;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  margin: left -10rem;
  flex-wrap: wrap;
  margin-left: -4rem;
}
.cityicon {
  border-right: 1px solid #ccc;  /* Add a right border */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.details-col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.details-col p, .details-col h6 {
  margin: 0.5rem 0;  /* space between items */
}
@media only screen and (max-width: 767px) {

  .large-logo {
    width: 100px;
  }
  
  .contact-row {
    padding-top: 1rem;
    padding-bottom: 1rem;
    text-align: center;
  }
  
  .cityicon > img {
    width: 70%;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  
  .address-icon, .phone-icon {
    width: 10%;
  }
  
  .address-text, .phone-text {
    width: 85%;
    margin-left: 5px;
  }
  .cityicon {
  border-right: none;  /* Add a right border */
  border-bottom: 1px solid #ccc;  /* Add a right border */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
}

@media only screen and (max-width: 480px) {
  .cityicon > img {
    width: 50%;
  }
.cityicon {
  border-right: none;  /* Add a right border */
  border-bottom: 1px solid #ccc;  /* Add a right border */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
  .form-card {
  border-radius: 12px;
  width: 100%;
  padding: 1rem;
  border: 1px solid #d3d3d3;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  margin-top: auto;
  margin-left: auto;
  margin-right: auto;
  flex-wrap: wrap;
}
  .address-text, .phone-text {
    width: 100%;
  }
}

/* ... other existing styles ... */
</style>
